import { cx } from '@linaria/core';
import { IconButton } from '@ui/kit';
import { button, meta, root } from './button.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createElement } from 'react';

function SolidContextMenuButton({
  inContextMenu,
  ...props
}) {
  const isPending = typeof props.async?.progress === "number" && props.async.progress === 0;
  const button$1 = /*#__PURE__*/createElement(IconButton, {
    ...props,
    ref: props.ref,
    className: cx(button, props.className),
    key: props.label,
    label: props.label,
    icon: props.icon,
    visibleLabel: true,
    state: isPending ? "pending" : props.state,
    async: props.state === "success" || "async" in props && props.async ? {
      showStatesAfterResult: true,
      showThrobberWhilePending: true
    } : undefined
  }, "async" in props && typeof props.async === "object" && /*#__PURE__*/jsxs("span", {
    className: cx(meta, typeof props.async.progress !== "undefined" && "active"),
    children: [Math.round((props.async.progress ?? 0) * 100), "%"]
  }));
  if (!inContextMenu) {
    return button$1;
  }
  return /*#__PURE__*/jsx("li", {
    className: root,
    children: button$1
  });
}

export { SolidContextMenuButton };
//# sourceMappingURL=button.js.map
